/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useQuery } from "@tanstack/react-query";
import { getProjectsList } from "./queryFunctions";
import { queryClient } from "@/utils/queryClient";
import { IWorkspace } from "@/interfaces/Workspace.interface";

export const useGetProjects = (workspaceId: string) => {
  /* 
  * NOTE: if this resource becomes paginated the
  * enabled condition will have to be refactored
  */
  const workspacesList = queryClient.getQueryData([
    "workspaces",
  ]) as IWorkspace[];
  const enabled = !!workspacesList?.find((item) => item.uuid === workspaceId);

  return useQuery({
    queryKey: ["projects", workspaceId],
    queryFn: () => getProjectsList(workspaceId),
    enabled,
  });
};
